import {BaseModel} from "../../base/models/base-model.model";
import {NotCreatedOrderModel} from "./not-created-order.model";
import {CreatedOrderModel} from "./created-order.model";

export class CreatedOrdersResponseModel extends BaseModel {
  private _createdOrders?: Array<CreatedOrderModel>;
  private _errors?: Array<NotCreatedOrderModel>;

  constructor(createdOrders?: Array<CreatedOrderModel>, errors?: Array<NotCreatedOrderModel>) {
    super();
    this._createdOrders = createdOrders;
    this._errors = errors;
  }

  get createdOrders(): Array<CreatedOrderModel> {
    return this._createdOrders;
  }

  set createdOrders(value: Array<CreatedOrderModel>) {
    this._createdOrders = value;
  }

  get errors(): Array<NotCreatedOrderModel> {
    return this._errors;
  }

  set errors(value: Array<NotCreatedOrderModel>) {
    this._errors = value;
  }
}
